/* unplugin-vue-components disabled */import script from "./swiperBox.vue?vue&type=script&lang=jsx"
export * from "./swiperBox.vue?vue&type=script&lang=jsx"

import "./swiperBox.vue?vue&type=style&index=0&id=9f343840&lang=less&scoped=true"

import exportComponent from "/data1/jenkins/master_project/website-sszx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f343840"]])

export default __exports__